( function($) {
	$(document).ready(function() {

		if ( $('iframe.dynamicheight').length ) {
			$('iframe.dynamicheight').iframedynheight({
				domain: 'dzhk.de'
			});
		}

		// $('.scrollable-box').each(function(){
		// 	$(this).lionbars({
		// 		autohide: true
		// 	});
		// });

		// add external icon
		$('.doc-article a[href^=http]').each(function(){
			$(this).append(' <i class="uk-text-small fa fa-external-link"></i>');
		});

		$('a[target="_blank"]').removeAttr('target');
		// open external links in new tab
		$('a[href^=http]:not([href*="://dzhk.de"])').on('click', function() {
			event.preventDefault();
			event.stopPropagation();
			window.open(this.href, '_blank');
		});

		// lightbox
		$( '.lightbox' ).on( 'click', function(e){
			e.preventDefault();
			var lightbox = UIkit.lightbox( this );
			lightbox.show();
		});

		/////////
		// DCE Extension dirty fix
		// remove multiple dce containers in translated language
		// since dce renders as many containers in target language 
		// as there are dce container elements in source language
		// TODO: check DCE updates for fix
		var countsc = 0;
		$( '.dce-slidercontainer, .dce-anchorscontainer' ).each(function(){
			countsc++;
			if ( countsc > 1 ) {
				$( this ).remove();
			}
		});
		/////////
		
		/*if($('.print').length > 0){
			$('.print').live('click', function(){
				$(this).parent().parent().parent().parent().printElement({
					printMode:'iframe',
					overrideElementCSS:['/fileadmin/default/templates/dzhk/css/printDatensatz.css'],
					pageTitle:'DZHK – Shared Expertise'
				});
				return false;
			});
		}*/

	});
} ) ( jQuery );
